import { notification, Spin } from 'antd';
import React, { createContext, FC, PropsWithChildren, useContext, useEffect, useState } from 'react';
import type { UseAuthType, User } from './data';
import { login, logout } from './login';
import { checkLogin } from './service';

const authContext = createContext({} as UseAuthType);

export interface AuthProviderProps {
  /** @default true */
  needLogin?: boolean;
}

const Provider = authContext.Provider;
const AuthProvider: FC<PropsWithChildren<AuthProviderProps>> = (props) => {
  const { needLogin = true } = props;
  const [user, setUser] = useState<User | null>(null);

  // 登录Auth
  useEffect(() => {
    getLoginStatus();
  }, []);

  async function getLoginStatus() {
    try {
      const { success, data, msg } = await checkLogin();
      if (success) {
        setUser(data);
        if (!data.isLogin && data.msg) {
          notification.error({ message: data.msg });
        }
      } else {
        setUser({ isLogin: false, msg });
      }
    } catch (error) {
      setUser({ isLogin: false, msg: '' });
    }
  }

  return user
    ? <Provider value={{ user, login, logout }} {...props} />
    : needLogin
      ? <Spin></Spin>
      : <Provider value={{ user: null, login, logout }} {...props} />
};

const useAuth = () => useContext(authContext);

export { default as AuthLayout } from './AuthLayout';
export { AuthProvider, useAuth };
export default AuthProvider;

